// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#view_promotion
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackViewPromotionItem extends Toolkit.GoogleAnalytics.AnyPromotionItem {}

export interface TrackViewPromotionParameters
    extends TrackEventBaseParameters<
        "creative_name" | "creative_slot" | "promotion_id" | "promotion_name",
        null,
        TrackViewPromotionItem
    > {}

const trackViewPromotion = (parameters: TrackViewPromotionParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "view_promotion", ...parameters }, options);
};

export default trackViewPromotion;
